/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Device Detector viewer — device / browser / OS with version breakdowns. */
(function () {
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.0, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["devicedetector"] = "1.2.7"; } catch (e) {}
  if (window.__ddWired) return; window.__ddWired = 1;
  var root;
  var DEV_ICON = { desktop: "bi-display", mobile: "bi-phone", tablet: "bi-tablet", tv: "bi-tv", other: "bi-question-circle" };
  function q(s) { return root ? root.querySelector('[data-d="' + s + '"]') : null; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function ready(fn) { var done = false; function go() { if (done) return; done = true; fn(); } document.addEventListener("gs:ready", go, { once: true }); var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30); if (window.GS && GS.api && GS.site) go(); }

  /* Accordion clicks are DELEGATED to the host, bound once. Per-row binding after render breaks the
     moment rows arrive incrementally (GSMore T("dd.load_more")): those rows never get a listener and the
     accordion is dead for them. Delegation survives any number of later insertions. */
  function wireExp(host) {
    if (!host || host._expWired) return;
    host._expWired = 1;
    host.addEventListener("click", function (e) {
      var hd = e.target && e.target.closest ? e.target.closest(".exp-hd") : null;
      if (!hd || !host.contains(hd)) return;
      var box = hd.parentNode;
      if (box && box.hasAttribute("data-exp")) box.classList.toggle("open");
    });
  }

  function ic(n) { return (window.GSIcons && GSIcons.svg) ? (GSIcons.svg(n, 16) + " ") : ""; }
  function renderDevices(devices) {
    var host = q("devices"); var max = devices.length ? devices[0].sessions : 1;
    if (!devices.length) { host.innerHTML = '<div class="empty">'+TR('dd.f.no_sessions_in_this_range')+'</div>'; return; }
    host.innerHTML = devices.map(function (d) {
      var icon = DEV_ICON[d.name] || DEV_ICON.other;
      return '<div class="dev-row"><span class="ic"><i class="bi ' + icon + '"></i></span>' +
        '<span class="nm">' + esc(d.name) + '</span>' +
        '<span class="track"><i style="width:' + Math.max(3, Math.round(d.sessions / max * 100)) + '%"></i></span>' +
        '<span class="val"><b>' + d.share + '%</b> \u00b7 ' + d.sessions.toLocaleString() + '</span></div>';
    }).join("");
  }

  function renderExp(host, rows, maxKnown) {
    if (!host) return;
    wireExp(host);
    if (!rows.length) { host.innerHTML = '<div class="empty">'+TR('dd.f.no_data_in_this_range')+'</div>'; return; }
    var max = rows[0].sessions || 1;
    function expRow(r, i) {
      var chip = r.top_version ? '<span class="chip">' + esc(r.name) + " " + esc(r.top_version) + "</span>" : "";
      var vers = (r.versions || []).map(function (v) {
        return '<div class="vrow"><span class="vv">' + esc(v.version) + '</span>' +
          '<span class="vt"><i style="width:' + Math.max(3, Math.round(v.sessions / (r.sessions || 1) * 100)) + '%"></i></span>' +
          '<span class="vn">' + v.sessions.toLocaleString() + " \u00b7 " + v.share + "%</span></div>";
      }).join("");
      return '<div class="exp' + (i === 0 ? " open" : "") + '" data-exp>' +
        '<div class="exp-hd"><span class="nm">' + ic(r.name) + esc(r.name) + " " + chip + "</span>" +
        '<span class="bar"><i style="width:' + Math.max(3, Math.round(r.sessions / max * 100)) + '%"></i></span>' +
        '<span class="meta">' + r.share + "% \u00b7 " + r.sessions.toLocaleString() +
        ' <i class="bi bi-chevron-right cv"></i></span></div>' +
        '<div class="exp-bd">' + vers + "</div></div>";
    }
    /* Long browser/OS lists page in rather than dumping every row at once. */
    if (window.GSMore) {
      GSMore.mount({ container: host, items: rows, pageSize: 12, render: expRow,
                     emptyHtml: '<div class="empty">'+TR('dd.f.no_data_in_this_range')+'</div>' });
    } else {
      host.innerHTML = rows.map(expRow).join("");
    }
  }

  function bar2(label, share, sessions, iconName) {
    return '<div class="brow2"><span class="bl">' + (iconName ? ic(iconName) : "") + esc(label) + "</span>" +
      '<span class="bt"><i style="width:' + Math.max(2, share) + '%"></i></span>' +
      '<span class="bv"><b>' + share + '%</b> \u00b7 ' + sessions.toLocaleString() + "</span></div>";
  }
  function titleCase(s) { s = String(s || ""); return s.charAt(0).toUpperCase() + s.slice(1); }

  function renderScreens(d) {
    var s = d.screens || {}, host = q("screens"), den = q("density");
    if (!s.available) { host.innerHTML = '<div class="empty">'+TR('dd.f.no_screen_data_in_this_range')+'</div>'; if (den) den.innerHTML = ""; return; }
    host.innerHTML = (s.resolutions || []).map(function (r) { return bar2(r.res, r.share, r.sessions); }).join("");
    if (den) den.innerHTML = (s.density && s.density.length)
      ? '<div class="dd-sub-h"'+T("dd.pixel_density")+'/div>' + s.density.map(function (x) { return '<span class="chip2">' + esc(x.label) + " <b>" + x.share + "%</b></span>"; }).join("")
      : "";
  }
  function renderCaps(d) {
    var c = d.capabilities || {}, host = q("caps");
    if (!c.available) { host.innerHTML = '<div class="empty">'+T("dd.capability_note1")+' <code>030</code> and the updated tracker are deployed.</div>'; return; }
    host.innerHTML = (c.items || []).map(function (i) { return bar2(i.label, i.share, i.sessions); }).join("");
  }
  function renderCross(host, cross, isDevice) {
    if (!cross || !cross.rows || !cross.rows.length) { host.innerHTML = '<div class="empty">'+TR('dd.f.no_data_in_this_range')+'</div>'; return; }
    host.innerHTML = cross.rows.map(function (row) {
      var segs = row.items.map(function (b, i) { return '<i class="seg s' + (i % 6) + '" style="width:' + Math.max(1, b.share) + '%" title="' + esc(b.name) + " " + b.share + '%"></i>'; }).join("");
      var chips = row.items.map(function (b) { return '<span class="cb"><i class="lg s' + (row.items.indexOf(b) % 6) + '"></i>' + ic(b.name) + esc(b.name) + " <b>" + b.share + "%</b></span>"; }).join("");
      var label = isDevice ? titleCase(row.key) : row.key;
      return '<div class="crow"><div class="ch"><span class="cn">' + ic(label) + esc(label) + '</span><span class="cs">' + row.sessions.toLocaleString() + ' sessions</span></div>' +
        '<div class="cbar">' + segs + "</div><div class=\"cbrk\">" + chips + "</div></div>";
    }).join("");
  }

  function render(d) {
    q("k-sessions").textContent = (d.totals.sessions || 0).toLocaleString();
    q("k-visitors").textContent = (d.totals.visitors || 0).toLocaleString();
    var k = d.kpi || {};
    q("k-browser").textContent = k.top_browser ? k.top_browser + (k.top_browser_version ? " " + k.top_browser_version : "") : "\u2014";
    q("k-os").textContent = k.top_os ? k.top_os + (k.top_os_version ? " " + k.top_os_version : "") : "\u2014";
    renderDevices(d.devices || []);
    renderExp(q("browsers"), d.browsers || []);
    renderExp(q("os"), d.os || []);
    // Engines arrive only once migration 052 has added the column. An empty list means the
    // column isn't there yet (or no traffic), so hide the whole card rather than draw an
    // empty box that looks like a bug.
    var eng = d.engines || [], engCard = document.querySelector('[data-d="engines-card"]');
    if (engCard) engCard.hidden = !eng.length;
    if (eng.length) renderExp(q("engines"), eng);
    renderScreens(d); renderCaps(d);
    renderCross(q("cross-bo"), (d.cross || {}).browser_os, false);
    renderCross(q("cross-db"), (d.cross || {}).device_browser, true);
    var note = q("vernote"); if (note) note.hidden = !!d.has_versions;
  }

  /* ── Device Intelligence ────────────────────────────────────────────────────
     Device crossed with behaviour, from /intel. Device is the one dimension every
     receiver already filters on, so these deep-links genuinely narrow the target
     plugin rather than dropping an ignored parameter into the URL. */
  var DI = { AC: "#1FA463", RD: "#DC2626", PU: "#6C4BE8", BL: "#2A6FE8", MU: "#8C95A1" };
  var DI_STAGES = ["exploration", "evaluation", "comparison", "commitment"];

  function diEsc(x) { return String(x == null ? "" : x).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function diNum(n) { n = +n || 0; return n >= 1e6 ? (n / 1e6).toFixed(1) + "M" : n >= 1e3 ? (n / 1e3).toFixed(1) + "k" : String(n); }
  function diLink(slug, dev) { return "/" + slug + "?device=" + encodeURIComponent(dev); }

  function diTriad(b) {
    if (!b) return '<div class="gs-muted small">'+TR('dd.f.no_behavioural_scores_yet')+'</div>';
    return [[TR('dd.f.intent'), b.intent, DI.AC], [TR('dd.f.friction'), b.frustration, DI.RD], [T("dd.attention"), b.attention, DI.PU]]
      .map(function (t) {
        return '<div class="di-tri"><span>' + t[0] + '</span><i><b style="width:'
             + Math.max(0, Math.min(100, t[1])) + "%;background:" + t[2] + '"></b></i><em>' + t[1] + "</em></div>";
      }).join("");
  }

  function diCards(d) {
    var host = q("di-cards"); if (!host) return;
    var rows = d.devices || [];
    if (!rows.length) { host.innerHTML = '<div class="empty">'+TR('dd.f.no_device_data_in_this_range')+'</div>'; return; }
    var note = q("di-note");
    if (note && !d.has_behaviour && d.notes && d.notes.behaviour) note.textContent = d.notes.behaviour;

    host.innerHTML = rows.map(function (r) {
      var p = (r.personas && r.personas[0]) || null;
      var land = (r.landing || []).slice(0, 3).map(function (l) {
        return '<a class="di-land" href="/heatmaps?page=' + encodeURIComponent(l.path)
             + "&device=" + encodeURIComponent(r.key) + '" title="Open this page in Heatmaps, filtered to '
             + diEsc(r.key) + '"><span>' + diEsc(l.path) + "</span><b>" + diNum(l.sessions) + "</b></a>";
      }).join("");
      return '<article class="di-card">'
        + '<div class="di-card-h">' + ic(r.key) + "<b>" + diEsc(r.key) + "</b><span>" + r.share + "%</span></div>"
        + '<div class="di-stats"><span>' + diNum(r.sessions) + " sessions</span><span>" + diNum(r.visitors)
        + " visitors</span><span>" + r.pages_per_session + " pages/visit</span></div>"
        + '<div class="di-triad">' + diTriad(r.behaviour) + "</div>"
        + (p ? '<div class="di-persona">'+T("dd.mostly")+' <b>' + diEsc(p.label) + "</b> · " + p.pct + "%</div>" : "")
        + (land ? '<div class="di-lands">' + land + "</div>" : "")
        + '<div class="di-links">'
        +   '<a href="' + diLink("user-flow", r.key) + '">'+TR('dd.f.flow')+'</a>'
        +   '<a href="' + diLink("funnels", r.key) + '"'+T("dd.funnels")+'/a>'
        +   '<a href="' + diLink("heatmaps", r.key) + '"'+T("dd.heatmaps")+'/a>'
        + "</div></article>";
    }).join("");
  }

  /* Journey stages as a stacked share per device: the shape of the bar is the story —
     a device whose bar is nearly all exploration never gets anyone to a decision. */
  function diJourney(d) {
    var host = q("di-journey"); if (!host) return;
    var rows = (d.devices || []).filter(function (r) { return r.journeys && r.journeys.length; });
    if (!rows.length) {
      host.innerHTML = '<div class="gs-muted small">' +
        (d.has_behaviour ? T("dd.no_journey") : (d.notes && d.notes.behaviour) || "") + "</div>";
      return;
    }
    var col = { exploration: "#8C95A1", evaluation: DI.BL, comparison: DI.PU, commitment: DI.AC };
    host.innerHTML = rows.map(function (r) {
      var by = {}; r.journeys.forEach(function (j) { by[String(j.label).toLowerCase()] = j.pct; });
      var segs = DI_STAGES.filter(function (s) { return by[s]; }).map(function (s) {
        return '<i style="width:' + by[s] + "%;background:" + col[s] + '" title="' + s + " " + by[s] + '%"></i>';
      }).join("");
      var top = r.journeys[0];
      return '<div class="di-jrow"><div class="di-jh">' + ic(r.key) + "<b>" + diEsc(r.key) + "</b>"
           + '<span class="gs-muted">' + diEsc(top.label) + " " + top.pct + "%</span></div>"
           + '<div class="di-jbar">' + segs + "</div></div>";
    }).join("")
    + '<div class="di-jkey">' + DI_STAGES.map(function (s) {
        return '<span><i style="background:' + col[s] + '"></i>' + s + "</span>"; }).join("") + "</div>";
  }

  function diRes(d) {
    var host = q("di-res"); if (!host) return;
    var rows = (d.resolutions || []).filter(function (r) { return r.sessions > 0; });
    if (!rows.length) { host.innerHTML = '<div class="empty">'+TR('dd.f.no_screen_data_in_this_range')+'</div>'; return; }
    var max = Math.max.apply(null, rows.map(function (r) { return r.sessions; }).concat([1]));
    host.innerHTML = rows.map(function (r) {
      var b = r.behaviour;
      return '<div class="di-rrow"><span class="di-rk">' + diEsc(r.key) + "</span>"
        + '<i class="di-rbar"><b style="width:' + Math.round(r.sessions / max * 100) + '%"></b></i>'
        + '<em>' + diNum(r.sessions) + "</em>"
        + (b ? '<span class="di-rb" title="intent ' + b.intent + " · friction " + b.frustration
             + " · attention " + b.attention + '">' + b.intent + " / " + b.frustration + "</span>"
             : '<span class="di-rb gs-muted">—</span>')
        + "</div>";
    }).join("")
    + '<div class="di-rkey gs-muted">bar = sessions · pair = intent / friction</div>';
  }

  /* A swallowed failure here is indistinguishable from "no data": the section simply never
     appears and there is nothing to debug. So the panel shows itself and says what went wrong. */
  function diFail(msg) {
    var wrap = q("di"); if (!wrap) return;
    wrap.hidden = false;
    var host = q("di-cards");
    if (host) host.innerHTML = '<div class="empty">' + diEsc(msg) + "</div>";
  }

  /* Model names come from the server, which resolved them from the stored viewport. The badge
     says how certain that is, because "iPhone 15" and "iPhone 15 or 15 Pro" are different claims. */
  /* Devices by brand — the same expandable list the browser breakdown uses, because a wall of
     cards makes 30 models unreadable. Brand rows collapse; models sit underneath with their share.
     Unbranded rows (desktop window sizes, unrecognised) are grouped last rather than pretending
     to be hardware. */
  /* Devices by brand, using the exact row shape the Browsers list uses: brand icon, name, a chip
     naming the most-used model, share bar, and versions underneath. Anything else on this page
     would look like a different product. */
  var DI_ICON = { "Desktop displays": "windows", "Unidentified": "" };

  /* Smartphones, tablets and computer displays are separated before anything else: they are not
     comparable, and a single ranked list buries a 3%-of-traffic phone under a monitor resolution.
     Within each class the rows are the same brand component the Browsers list uses. */
  var DI_CLASS = [
    ["smartphone", TR('dd.f.smartphones'), "phone"],
    ["tablet",     TR('dd.f.tablets'),     "tablet"],
    ["computer",   TR('dd.f.computer_displays'), "windows"],
    ["tv",         TR('dd.f.tv_consoles'), ""],
    ["console",    TR('dd.f.tv_consoles'), ""],
    ["other",      TR('dd.f.unclassified'), ""]
  ];
  var DI_ICON = { "Desktop displays": "windows", "Unidentified": "" };

  function diModels(d) {
    var host = q("di-models"); if (!host) return;
    var rows = d.models || [];
    if (!rows.length) { host.innerHTML = '<div class="empty">'+TR('dd.f.no_screen_sizes_recorded_in_this_range')+'</div>'; return; }

    // bucket by physical class, merging tv+console into one section
    var byClass = {};
    rows.forEach(function (m) {
      var c = m["class"] || "other";
      if (c === "console") c = "tv";
      (byClass[c] = byClass[c] || []).push(m);
    });

    var seen = {}, out = "";
    DI_CLASS.forEach(function (spec) {
      var key = spec[0] === "console" ? "tv" : spec[0];
      if (seen[spec[1]] || !byClass[key] || !byClass[key].length) return;
      seen[spec[1]] = 1;
      out += diClassSection(spec[1], spec[2], byClass[key]);
    });
    host.innerHTML = out || '<div class="empty">'+TR('dd.f.no_screen_sizes_recorded_in_this_range')+'</div>';
    wireExp(host);
  }

  function diClassSection(title, iconKey, models) {
    var groups = {}, order = [];
    models.forEach(function (m) {
      var b = m.brand && m.brand !== "" ? m.brand
            : (m.confidence === "class" ? "Desktop displays" : TR('dd.f.unidentified'));
      if (!groups[b]) { groups[b] = { name: b, sessions: 0, models: [], soft: (b === TR('dd.f.desktop_displays') || b === TR('dd.f.unidentified')) }; order.push(b); }
      groups[b].sessions += m.sessions;
      groups[b].models.push(m);
    });
    var list = order.map(function (k) { return groups[k]; });
    list.sort(function (a, b) { return (a.soft - b.soft) || (b.sessions - a.sessions); });

    /* Shares are within the class: 30% of tablet traffic is a useful number, 0.4% of everything
       is not. The heading carries the class's own total for context. */
    var total = list.reduce(function (n, g) { return n + g.sessions; }, 0) || 1;
    var max = list[0].sessions || 1;

    var body = list.map(function (g, i) {
      g.models.sort(function (a, b) { return b.sessions - a.sessions; });
      var top = g.models[0];
      var chip = top ? '<span class="chip">' + diEsc(diShort(top.name, g.name)) + "</span>" : "";
      var brandIcon = (DI_ICON[g.name] !== undefined) ? DI_ICON[g.name] : g.name;
      var rowsHtml = g.models.map(function (m) {
        var flags = (m.confidence === "approximate" ? '<span class="di-t di-t-approx" title=T("dd.android_note")>approx</span>' : "")
                  + (m.ambiguous ? '<span class="di-t di-t-amb" title=T("dd.viewport_note")>shared</span>' : "");
        var life = (m.released != null ? m.released + (m.discontinued != null ? "\u2013" + m.discontinued : "\u2013now") : "");
        return '<div class="vrow" title="' + diEsc(m.tooltip || "") + '">'
             + '<span class="vv">' + diEsc(diShort(m.name, g.name)) + flags + "</span>"
             + '<span class="vt"><i style="width:' + Math.max(3, Math.round(m.sessions / (g.sessions || 1) * 100)) + '%"></i></span>'
             + '<span class="vn">' + diNum(m.sessions) + " \u00b7 " + m.share + "%</span>"
             + (life ? '<span class="di-life">' + life + "</span>" : "")
             + "</div>";
      }).join("");
      var share = Math.round(g.sessions / total * 1000) / 10;
      return '<div class="exp' + (i === 0 ? " open" : "") + '" data-exp>'
        + '<div class="exp-hd"><span class="nm">' + (brandIcon ? ic(brandIcon) : "") + diEsc(g.name) + " " + chip + "</span>"
        + '<span class="bar"><i style="width:' + Math.max(3, Math.round(g.sessions / max * 100)) + '%"></i></span>'
        + '<span class="meta">' + share + "% \u00b7 " + diNum(g.sessions) + ' <i class="bi bi-chevron-right cv"></i></span></div>'
        + '<div class="exp-bd">' + rowsHtml + "</div></div>";
    }).join("");

    return '<div class="di-class"><div class="di-class-h">' + (iconKey ? ic(iconKey) : "")
         + "<b>" + diEsc(title) + "</b><span>" + diNum(total) + " sessions</span></div>" + body + "</div>";
  }


  /* "Samsung Galaxy S23 Ultra" under a Samsung heading reads as a stutter; drop the brand prefix
     the way the browser list shows "150" rather than "Chrome 150" in its rows. */
  function diShort(name, brand) {
    name = String(name || "");
    if (brand && name.toLowerCase().indexOf(brand.toLowerCase() + " ") === 0)
      return name.slice(brand.length + 1);
    return name;
  }



  function loadIntel() {
    var wrap = q("di");
    if (!wrap) { if (window.console) console.warn("[devicedetector] no [data-d=\"di\"] in the page — template not deployed?"); return; }
    if (!window.GS || !GS.api) { diFail(TR('dd.f.ghoststat_app_scripts_did_not_load')); return; }
    if (!GS.site) return;                       // gs:ready re-fires this
    GS.api("/plugin/devicedetector/intel?" + siteParam() + "&from=" + RANGE.from + "&to=" + RANGE.to)
      .then(function (r) {
        var d = (r && r.data) ? r.data : r;
        if (!d) { diFail(TR('dd.f.no_response_from_the_intel_endpoint')); return; }
        if (d.gated) { diFail(TR('dd.f.device_intelligence_isn_t_available_on')); return; }
        if (d.error === "plugin_not_loaded") { diFail(TR('dd.f.devicedetector_isn_t_enabled_for_this_')); return; }
        if (!d.devices) {
          diFail(TR('device.p.the_intel_endpoint_returned_nothing_')
               + "(plugins/devicedetector/backend/intel.php + api/lib/DimensionIntel.php)");
          return;
        }
        wrap.hidden = false;
        var t = q("di-tot");
        if (t && d.totals) t.innerHTML = diNum(d.totals.sessions) + " sessions &middot; " + diNum(d.totals.visitors) + " visitors";
        diCards(d); diModels(d); diJourney(d); diRes(d);
      })
      .catch(function (e) {
        diFail(TR('device.p.could_not_load_device_intelligence') + ((e && e.message) || "request failed") + ").");
        if (window.console) console.warn("[devicedetector] intel request failed", e);
      });
  }

  function load() {
    loadIntel();
    GS.api("/plugin/devicedetector/overview?" + siteParam() + "&from=" + RANGE.from + "&to=" + RANGE.to).then(function (r) {
      if (r.ok && r.data) render(r.data);
    });
  }

  function _ymd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
  function _today() { var t = new Date(); return new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days) { var to = _today(), from = new Date(to.getTime() - (days - 1) * 86400000); var lbl = { 7: T("an.last7"), 30: T("an.last30"), 90: T("an.last90"), 365: T("an.last12mo") }[days] || T("an.lastndays",{n:days}); return { from: _ymd(from), to: _ymd(to), label: lbl, preset: String(days) }; }
  var RANGE = (function () { try { var s = JSON.parse(localStorage.getItem("gs_dd_range") || "null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if (s && s.from && s.to) return s; } catch (e) {} return preset(30); })();
  function saveRange() { try { localStorage.setItem("gs_dd_range", JSON.stringify(RANGE)); } catch (e) {} }

  function initRange() {
    var btn = q("rangeBtn"), menu = q("rangeMenu"), lab = q("range-label"); if (!btn || !menu) return;
    if (lab && RANGE.label) lab.textContent = RANGE.label;
    function sync() { menu.querySelectorAll(".rm[data-preset]").forEach(function (x) { x.classList.toggle("on", x.getAttribute("data-preset") === RANGE.preset); }); }
    sync();
    btn.addEventListener("click", function (e) { if (menu.contains(e.target) && e.target !== btn) return; e.stopPropagation(); var open = menu.style.display !== "none"; menu.style.display = open ? "none" : "block"; if (!open) { var cf = menu.querySelector('[data-rp="from"]'), ct = menu.querySelector('[data-rp="to"]'); if (cf) cf.value = RANGE.from; if (ct) ct.value = RANGE.to; sync(); } });
    document.addEventListener("click", function () { menu.style.display = "none"; });
    menu.addEventListener("click", function (e) { e.stopPropagation(); });
    function apply(r) { RANGE = r; if (lab) lab.textContent = RANGE.label; saveRange(); menu.style.display = "none"; load(); }
    menu.querySelectorAll(".rm[data-preset]").forEach(function (b) { b.addEventListener("click", function () { apply(preset(+b.getAttribute("data-preset"))); }); });
    var ap = menu.querySelector('[data-rp="apply"]'); if (ap) ap.addEventListener("click", function () { var f = menu.querySelector('[data-rp="from"]').value, t = menu.querySelector('[data-rp="to"]').value; if (!f || !t) return; if (f > t) { var x = f; f = t; t = x; } apply({ from: f, to: t, label: f + " \u2192 " + t, preset: null }); });
  }
  function init() { root = document.querySelector('[data-d="root"]'); if (!root) return; var rf = q("refresh"); if (rf) rf.addEventListener("click", load); initRange(); load(); }
  ready(init);
})();
